class ThemeHeader extends HTMLElement {
    constructor() {
        super();

        //this.menu_container = this.querySelector('#menu-container');

        this.querySelectorAll('.site-nav--has-dropdown button.site-nav__link').forEach(
            (trigger) => {
                trigger.addEventListener(
                    'mouseover', () => {
                        this.openMenu(trigger.getAttribute('aria-controls'));
                        this.changeStatusLink(trigger, true);
                    }
                )
            }
        )

        /**window.addEventListener('resize', () => this.calculateHeader());
        this.calculateHeader();**/

        this.addEventListener('mouseleave', () => this.openMenu(''));
    }

    changeStatusLink(trigger, status) {
        trigger.classList.toggle('site-nav__link--active', status);
        trigger.closest('li').classList.toggle('site-nav--active', status);
    }

    openMenu(menu) {
        this.querySelectorAll('.site-nav__dropdown').forEach(
            (dropdown) => {
                if(dropdown.id !== menu) {
                    dropdown.removeAttribute('style');
                }
            }
        )

        this.querySelectorAll('.site-nav--has-dropdown button.site-nav__link').forEach(
            (trigger) => {
                if(trigger.getAttribute('aria-controls')) {
                    this.changeStatusLink(trigger, false);
                }
            }
        )

        document.getElementById(menu).style.display = 'block';
    }

    calculateHeader() {
        let menu_container = this.querySelector('#menu-container');
        let max_heigth = 0;
        menu_container.querySelectorAll('.menu-block').forEach(
            (card) => {
                if (card.offsetHeight > max_heigth) {
                    max_heigth = card.offsetHeight;
                }
            }
        )
        menu_container.style.height = max_heigth + 'px';
    }

    execute() {
        let headerContainer = document.querySelector('header.shopify-section-header') || false;

        headerContainer?.classList.toggle("hide",
            window.scrollY > this.lastKnownScrollPosition && window.scrollY > headerContainer.offsetHeight
        );
    }
}
customElements.define('theme-header', ThemeHeader);